import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import type { MontarEntrada } from "@noesis/shared";
import { pedir } from "../api.js";

/**
 * "Praticar" a partir de um número (handoff de UI/UX, ADR 039): monta uma
 * sessão só daquele assunto e leva para ela. É a mesma montagem da tela
 * Estudar, com o filtro já escolhido — nenhuma regra nova.
 *
 * O Diagnóstico conhece o assunto pelo caminho ("Matéria › Assunto") e não
 * pelo id; o id sai das opções de estudo, que listam as categorias na ordem da
 * árvore com a profundidade de cada uma.
 */
export function usePraticar() {
  const navegar = useNavigate();
  const [ocupado, setOcupado] = useState<string | null>(null);

  const praticar = useCallback(
    async (chave: string, alvo: { categoriaId?: string; caminho?: readonly string[] }, extra: Partial<MontarEntrada> = {}) => {
      setOcupado(chave);
      try {
        const categoriaId = alvo.categoriaId ?? (alvo.caminho ? await idDoCaminho(alvo.caminho) : undefined);
        if (!categoriaId) return;
        const r = await pedir("estudo.montar", {
          corpo: { categoriaIds: [categoriaId], priorizarMaisErrados: true, ...extra },
        });
        if (r.montada) void navegar("/estudar");
      } finally {
        setOcupado(null);
      }
    },
    [navegar],
  );

  return { praticar, ocupado };
}

async function idDoCaminho(caminho: readonly string[]): Promise<string | undefined> {
  const { categorias } = await pedir("estudo.opcoes");
  const pilha: string[] = [];
  for (const c of categorias) {
    pilha.length = c.profundidade;
    pilha.push(c.nome);
    if (pilha.length === caminho.length && pilha.every((n, i) => n === caminho[i])) return c.id;
  }
  return undefined;
}
